
<template>
  <div class="heads noSel" id="titleBar">
    <div class="headerWrap" >
      <div class="logo"  @click="goLinks('/')">
         <img src="../../assets/images/logo.png" />
		    <div class="name" style="margin-left: 20px;">
            {{siteName}}
        </div>
      </div>
      <div class="navWrap">
        <div class="li" @click="popHide('video')">
          <div class="icon">
            <img :src="isVideo?navLi[3].icon2:navLi[3].icon1" alt />
          </div>
          <div class="name">视频课程</div>
        </div>
        <!-- <div class="li" @click="popHide('pingyin')">
					<div class="icon">
						<img :src="isPy?navLi[3].icon2:navLi[3].icon1" alt="">
					</div>
					<div class="name">拼音工具</div>
        </div>-->
      </div>
      <div style="width: 910px;"></div>
      <div class="headRingt">
       <div class="score" @click="outCase()" style="margin-right: 20px;" >
          <span class="le">退出模拟</span>
        </div>
        <div class="headTx" v-if="token" @click="isUse=!isUse">
          <img src="../../assets/images/avatar.png" alt />
          <div class="opList" v-if="isUse">
            <ul>
              <div class="iconsj"></div>
              <li @click.stop="outLogin">
                <span>退出登录</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="ul" v-else>
          <div class="li login" @click="LoginFun">登录</div>
        </div>
      </div>
    </div>
    <div class="videoIc" v-if="loginStaie.isshowVideo" @click="resumeVideo()">
      <img src="../../assets/images/live.png" alt />
    </div>
  </div>
</template>
<script>
// import qs from 'qs'
export default {
  name: "heads",
  data: function() {
    return {
      token: "",
      isFeedbac: false,
      fileList: [],
      feedbackLi: {
        contract: "",
        content: ""
      },
      loginIndex: 1,
      rlen: history.length,
      isTwo: false,
      isTherr: false,
      iszl: false,
      navIndex: 0,
      navLi: [
        {
          icon1: require("../../assets/images/site/li_ci2.png"),
          icon2: require("../../assets/images/site/li_cis2.png")
        },
        {
          icon1: require("../../assets/images/site/li_ci3.png"),
          icon2: require("../../assets/images/site/li_cis3.png")
        },
        {
          icon1: require("../../assets/images/site/li_ci1.png"),
          icon2: require("../../assets/images/site/li_cis1.png")
        },
        {
          icon1: require("../../assets/images/site/videoImg.png"),
          icon2: require("../../assets/images/site/videoImg.png")
        }
      ],
      isHole: false,
      isUse: false,
      isSetPwd: false,
      isCommom: false,
      isLogin: false,
      regIndex: null,
      isDisabled: false,
      isReg: false
    };
  },
  props: [
    "siteName",
    "cancalChild",
    "isVideo",
  ],
  components: {},
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loginStaie() {
      return this.$store.getters.loginStaie;
    }
  },
  created() {
    this.token = localStorage.getItem("eleToken");
  },
  mounted() {
	  // document.getElementById("winMin").addEventListener("mousedown", e => {
    //   if (e.button == 0) up.minimize();
    // });
    // document.getElementById("titleBar").addEventListener("dblclick", e => {
    //   up.maximize();
    // });
    // document.getElementById('winMax').addEventListener('mousedown', (e) => {
    // 	if (e.button == 0) up.maximize();
    // })
    // document.getElementById("winCls").addEventListener("mousedown", e => {
    //   if (e.button == 0) up.close();
    // });
    /* eslint-disable */
  },
  methods: {
   outCase(){
    this.popHide("outCase");
  },
	LoginFun(){
		this.goLinks('/')  
		 this.$store.dispatch("loginState", { isShowLogin: true });
	},
    resumeVideo() {
      this.$axios
        .get("http://127.0.0.1:17990/GET?Info=resumeVideo")
        .then(res => {
          let data = res.data;
          if (data.code == 0) {
          }
        });
      this.$store.dispatch("loginState", { isshowVideo: false });
    },
    goReg(e) {
      this.goRegPage(e);
      this.regIndex = e;
      this.popHide("isLeasing");
    },
    score() {
      this.popHide("score");
    },
    goBack() {
      sessionStorage.clear();
      let len = this.rlen - history.length - 1; //-1是不进入iframe页面的下级页面直接退出的话，执行后退一步的操作
      this.$router.go(len);
    },
    popHide(e) {
      this.cancalChild(e);
    },
    outLogin() {
      localStorage.clear();
      sessionStorage.clear();
      this.$store.dispatch("clearCurrentState");
      this.isUse = false;
      this.goLinks("/");
    },
    colPop() {
      this.isLogin = false;
      this.isReg = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.titleBar {
  position: relative;
  display: flex;
  align-items: center;
  background: #333;
  // min-height: 2em;
  width: 100vw;
  -webkit-app-region: drag;
}

/*      .form {
		position: relative;
		display: flex;
		flex-direction: column;
		height: calc(100vh - 2em);
		width: 100vw;
	} */
// #appWinIcons .txWrap {
//   width:55px;
//   display: flex;
//   justify-content: flex-end;
//   position: relative;
// }
// #appWinIcons {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// 	padding-right: 15px;
//     padding-left: 30px;
//     min-height: 100%;
//     width: 70px;
// }

.winIco:hover {
  color: #000 !important;
}

.winIco {
  color: #999;
  cursor: pointer;
}

#winMin {
  position: relative;
}

#winMax {
  position: relative;
  bottom: 2px;
  font-size: 2em;
}

#winCls {
  position: relative;
  top: 1px;
  font-size: 2em;
}
.logo {
  display: flex;
  align-items: center;
  max-width: 300px;
  height: 50px;
  margin: 0 0 0 30px;
  .tx {
    width: 25px;
    height: 25px;
    background: #eeeeee;
    border-radius: 50%;
    margin-left: 20px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.logo img {
  height: 50px;
  cursor: pointer;
}

.videoIc {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 150px;
  right: 100px;
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
  }
}
.listPop {
  position: absolute;
  width: 227px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 2px;
  right: -42px;
  top: 69px;
  .iconsj {
    transform: rotate(180deg);
    position: absolute;
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    top: -20px;
    right: 105px;
  }
  ul {
    height: 369px;
    // overflow-x: auto;
    li {
      width: 227px;
      height: 41px;
      line-height: 41px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      text-align: left;
      cursor: pointer;
      padding-left: 23px;
      color: #57616c;
      font-size: 12px;
      padding-right: 51px;
      position: relative;
      .mark {
        position: absolute;
        left: 176px;
        top: 0;
      }
      .colorOne {
        color: #158437;
      }
      .colorTwo {
        color: #ff0000;
      }
      .thrr {
        color: #57616c;
      }
      .lists {
        width: 227px;
        position: absolute;
        right: -250px;
        display: none;
        top: 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 2px;
        .iconsj {
          transform: rotate(90deg);
          top: 5px;
          right: 226px;
        }
        .ul {
          max-height: 369px;
          overflow-x: auto;
          .li {
            width: 227px;
            height: 41px;
            line-height: 41px;
            box-sizing: border-box;
            border-bottom: 1px solid #eeeeee;
            text-align: left;
            cursor: auto;
            padding-left: 23px;
            color: #57616c;
            font-size: 12px;
            padding-right: 51px;
            position: relative;
            margin-left: 0;
          }
        }
      }
    }
    .colorFont {
      color: #999999;
    }
    li:hover {
      background-color: #f3cd70;
    }
    li:hover .lists {
      display: block;
    }

    // .avt{
    // 	background-color: #F3CD70;
    // }
  }
}
.headerWrap .left {
  display: flex;
}
.headerWrap .site {
  line-height: 80px;
  font-size: 14px;
  margin-left: 20px;
}
.iconLeft {
  color: #2f3a48;
  background-color: #f3cd70;
  width: 30px;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
}
.iconLeft img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-top: -3px;
}
.holePop {
  position: fixed;
  background-color: #ffffff;
  left: 50%;
  top: 50%;
  z-index: 99;
  width: 400px;
  height: 362px;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 24px;
  text-align: center;
}
.headTi {
  position: relative;
  border-bottom: 1px solid #e8e8e8;
  height: 40px;
  line-height: 43px;
  font-size: 12px;
  text-align: left;
}
.holePop .lex {
  line-height: 17px;
  font-size: 12px;
  margin-top: 30px;
}
.holePop .code {
  margin-top: 20px;
}
.holePop .code img {
  width: 120px;
  height: 120px;
}
.holePop .ft {
  border-top: 1px dashed #e8e8e8;
  margin-top: 25px;
}
.holePop .ft .leq {
  margin-top: 16px;
  font-size: 12px;
}
.holePop .ft .des {
  margin-top: 5px;
  font-size: 12px;
}
.holePop .ft .dexs {
  color: #178aff;
  margin-top: 12px;
  font-size: 12px;
  cursor: pointer;
}
.feedbackPop {
  position: fixed;
  background-color: #fafafa;
  left: 50%;
  top: 50%;
  z-index: 99;
  width: 450px;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 26px 64px 26px;
  // text-align: center;
  .feedbac {
    position: relative;
    .icon {
      position: absolute;
      right: 0;
      top: 12px;
      cursor: pointer;
      img {
        width: 10px;
        height: 10px;
      }
    }
  }
  .sBtn {
    position: absolute;
    width: 78px;
    height: 30px;
    background: rgba(23, 138, 255, 1);
    opacity: 1;
    font-size: 12px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    border-radius: 6px;
    right: 0;
    bottom: -52px;
    cursor: pointer;
  }
  .title {
    padding-top: 24px;
    margin-bottom: 17px;
    font-size: 12px;
  }
  .textCont {
    display: flex;
    margin-bottom: 10px;
    .name {
      width: 66px;
      font-size: 12px;
      line-height: 30px;
      height: 30px;
    }
    .tex {
      flex: 1;
      textarea {
        height: 122px;
        width: 100%;
        resize: none;
        outline: none;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 225, 226, 1);
        opacity: 1;
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 12px;
        padding: 10px;
      }
      .odPik {
        width: 47px;
        height: 47px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 225, 226, 1);
        opacity: 1;
        border-radius: 2px;
        text-align: center;
        color: #e8e8e8;
        font-size: 18px;
        line-height: 47px;
        cursor: pointer;
      }
      .dev {
        height: 14px;
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 14px;
        color: rgba(146, 145, 147, 1);
        opacity: 1;
        padding-top: 4px;
      }
      input {
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(225, 225, 226, 1);
        box-sizing: border-box;
        opacity: 1;
        width: 100%;
        padding: 7px;
        border-radius: 4px;
        font-size: 12px;
        outline: none;
      }
    }
    .upload {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.headTi .icon {
  position: absolute;
  right: 0;
  top: 15px;
  width: 12px;
  height: 12px;
  cursor: pointer;
}
.headTi .icon img {
  width: 12px;
  vertical-align: top;
  height: 12px;
}
.headerWrap {
  background-color: #ffffff;
  height: 80px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
}
.navWrap {
  display: flex;
  // position: absolute;
  align-items: center;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  .pageBtn {
    width: 120px;
    height: 40px;
    border: 1px solid #57616c;
    opacity: 1;
    line-height: 40px;
    border-radius: 4px;
    color: #57616c;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
  }
  .leftBtn {
    margin-left: 116px;
  }
  .noAvt {
    color: #e8e8e8;
    border: 1px solid #e8e8e8;
  }
}
.navWrap .li {
  margin-left: 30px;
  font-size: 14px;
  height: 80px;
  cursor: pointer;
  position: relative;
}

.navWrap .li .icon {
  margin-top: 26px;
  text-align: center;
  line-height: 20px;
}
.navWrap .li .icon img {
  width: 16px;
  vertical-align: middle;
}
.navWrap .li .name {
  margin-top: 11px;
  font-size: 12px;
  color: #57616c;
}
.navWrap .li:first-of-type {
  margin-left: 0;
}
.navWrap .avt .name {
  color: #000000;
  position: relative;
}
.navOpList {
  width: 0;
  height: 0;
  position: relative;
}
.navOpList .opList {
  top: 11px;
  right: auto;
  left: -52px !important;
  width: 180px;
  display: none;
}
// .navWrap .li:hover .navOpList .opList{
// 		display: block;
// }
.navOpList .opList .iconsj {
  right: 82px;
}
.navOpList .opList ul li {
  text-align: left;
  padding-left: 30px;
  box-sizing: border-box;
  width: 180px;
}
.navWrap .score {
  cursor: pointer;
  width: 160px;
  height: 40px;
  border: 1px solid #f3cd70;
  border-radius: 20px;
  line-height: 40px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
}
.navWrap .score .le {
  font-size: 12px;
  color: #57616c;
  vertical-align: middle;
}
.navWrap .score .de {
  font-size: 20px;
  color: #57616c;
  margin-left: 9px;
  vertical-align: middle;
  cursor: pointer;
}
.navWrap .avtScore {
  background-color: #f3cd70;
}
.navWrap .magger {
  position: relative;
}
.navWrap .magger .de {
  font-size: 12px;
  display: inline-block;
  width: 70px;
  overflow: hidden;
  height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navWrap .magger .icon {
  width: 10px;
  height: 6px;
  margin-left: 21px;
  img {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
}
.headRingt {
  display: flex;
  align-items: center;
  margin-right: 24px;
  .score {
    width: 110px;
    height: 32px;
    cursor: pointer;
    background: #f3cd70;
    opacity: 1;
    text-align: center;
    border-radius: 4px;
    line-height: 32px;
    font-size: 14px;
    color: #232f3e;
    .le {
      font-size: 14px;
      color: #232f3e;
    }
    .de {
      font-size: 14px;
      color: #232f3e;
    }
  }
}
.headRingt .more {
  display: flex;
  cursor: pointer;
}
.headRingt .more img {
  width: 14px;
  height: 14px;
}
.headRingt .more span {
  font-size: 12px;
  height: 14px;
  line-height: 14px;
  margin-left: 9px;
}
.headRingt .ul {
  display: flex;
  margin-left: 40px;
}
.headRingt .ul .li {
  width: 80px;
  height: 40px;
  background-color: #f3cd70;
  border-radius: 21px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  color: #232f3e;
}
.headRingt .ul .reg {
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e1e1e2;
  margin-left: 10px;
}
.headTx {
  width: 40px;
  height: 40px;
  background-color: #f3cd70;
  border-radius: 50%;
  margin-left: 40px;
  cursor: pointer;
  position: relative;
}
.headTx img {
  width: 100%;
}
.isCode {
  background-color: #cccccc !important;
}
.layui-btn {
  text-align: center;
}

.pop_bg {
  width: 100%;
  left: 0px;
  top: 0px;
  height: 100%;
  position: fixed;
  /*    user-select: none; */
  z-index: 99;
  background-color: #000;
  opacity: 0.5;
}
.tsPop {
  position: fixed;
  background-color: #cf5d4f;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 9999999;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  border-radius: 5px;
  width: 260px;
  height: 60px;
  color: #fff;
  font-size: 14px;
  line-height: 60px;
  text-align: center;
}
.loginPop {
  position: fixed;
  background-color: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 9999999;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  border-radius: 5px;
}
.popWrap {
  box-sizing: border-box;
  position: relative;
  padding: 14px 45px 0;
  width: 350px;
  height: 480px;
}
.popTab {
  border-bottom: 1px solid #e1e1e2;
}
.popTab ul li {
  float: left;
  padding: 12px 0;
  width: 50%;
  text-align: center;
  height: 12px;
  line-height: 12px;
}
.popTab ul li a {
  font-size: 12px;
  color: #929193;
  position: relative;
}
.popTab ul .avt a {
  color: #178aff;
}
.popTab ul .avt a:after {
  content: "";
  position: absolute;
  background-color: #178aff;
  height: 2px;
  width: 100%;
  bottom: -9px;
  left: 0;
}
.popCode {
  border: 1px solid #e1e1e2;
  width: 260px;
  height: 260px;
  box-sizing: border-box;
  padding: 15px 11px 13px 14px;
  margin-top: 46px;
}
.popCode img {
  width: 235px;
  height: 232px;
}
.popTs {
  margin-top: 38px;
  text-align: center;
}
.popBox .layui-form {
  margin-top: 32px;
}
.popBox .login-btn {
  padding-top: 20px;
}
.popBox .layui-btn {
  width: 100%;
  background-color: #178aff;
}
.popBox .layui-input-inline {
  width: 100%;
  margin-bottom: 10px;
  position: relative;
}
.popBox .paswordPop {
  position: relative;
}
.popBox .paswordPop .noPwd {
  position: absolute;
  right: 14px;
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  color: #777777;
  top: 14px;
  cursor: pointer;
  z-index: 99;
}
.popBox .paswordPop input {
  padding-right: 100px;
}
.popBox .layui-input-inline input {
  border: 1px solid #e1e1e2;
  padding-left: 16px;
}
.popBox .layui-input-inline button {
  height: 40px;
  line-height: 40px;
  border: 0;
  border-radius: 3px;
  color: #ffffff;
}
.popBox .layui-input-inline input,
.popBox .layui-form .layui-btn {
  height: 40px;
  line-height: 40px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 3px;
}
.popBox .layui-form .layui-btn {
  border: 0;
  color: #ffffff;
}
.popBox .layui-input-inline .codes,
.popBox .layui-input-inline .btnCode {
  width: 125px;
  box-sizing: border-box;
}
.popBox .layui-input-inline .codes {
  border: 1px solid #e1e1e2;
}
.loginPop .icon {
  position: absolute;
  right: 9px;
  top: 14px;
  cursor: pointer;
}
.loginPop .icon img {
  width: 10px;
  height: 10px;
}
.popBox .layui-input-inline .btnCode {
  margin-left: 10px;
  background-color: #178aff;
  color: #fff;
  border: 0;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  border-radius: 5px;
  padding-left: 0 !important;
}
.popWrap .linkPop {
  position: absolute;
  bottom: 30px;
  text-align: center;
  width: 100%;
  height: 14px;
  line-height: 14px;
  left: 0;
}
.linkPop a {
  color: #333333;
  font-size: 14px;
  cursor: pointer;
}
.tips {
  margin-top: 21px;
}
.tips p {
  font-size: 14px;
  color: #333333;
  text-align: center;
}
.popError {
  position: absolute;
  right: 0;
  top: -1px;
}
.popError .err {
  width: 12px;
  border: 1px solid #cf5d4f;
  height: 12px;
  text-align: center;
  box-sizing: border-box;
  line-height: 7px;
  border-radius: 50%;
  float: right;
}
.popError span {
  float: right;
  color: #cf5d4f;
  font-size: 12px;
  margin-left: 7px;
  line-height: 12px;
}

.popError .err img {
  width: 7px;
}
.popBox .upPhone .layui-btn {
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #178aff;
  color: #333333;
}
.opList {
  background-color: #ffffff;
  border-radius: 3px;
  width: 100px;
  position: absolute;
  right: -1px;
  top: 72px;
  z-index: 9999;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
}
.opList ul {
  position: relative;
}
.opList .iconsj {
  transform: rotate(180deg);
  position: absolute;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
  top: -20px;
  right: 11px;
}
.opList ul li {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eeeeee;
  width: 100px;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.opList ul li:last-of-type {
  border-bottom: 0;
}
.opList ul li span {
  color: #333;
  font-size: 12px;
}
</style>
